import TopNav from "../components/TopNav.jsx";
import ProductMark from "../components/ProductMark.jsx";

/**
 * StadiumSeatPage · /stadium-seat
 * Coming soon · a complete purchasable business package for any bar and
 * grill (POS, inventory, staff, menu, marketing, delivery, compliance),
 * given free to Earth as long as the law allows.
 */
export default function StadiumSeatPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain" data-testid="stadium-seat-page">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">

        <div className="border-4 border-sage-accent bg-sage-accent text-sage-bg px-4 py-3 inline-block mb-6" data-testid="stadium-seat-coming-soon">
          <span className="text-xs uppercase tracking-[0.3em] font-bold">Coming soon · in build</span>
        </div>

        <div className="text-[10px] uppercase tracking-[0.3em] text-sage-accent mb-3">FREE FOREVER · SMALL-BUSINESS TIER</div>
        <div className="flex items-start gap-4 mb-4">
          <div className="text-sage-accent shrink-0"><ProductMark slug="stadium-seat" size={48} /></div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase">Stadium Seat</h1>
        </div>
        <p className="text-lg text-sage-muted leading-relaxed max-w-3xl mb-10 sage-prose">
          The complete business-in-a-box any bar, grill, cafe, food truck, or small restaurant would normally have to license, subscribe to, and glue together across a dozen vendors — Sage builds it as one package and gives it to Earth for free, for as long as the law allows.
        </p>

        <div className="border border-sage-warn p-6 mb-10 bg-sage-surface" data-testid="stadium-seat-legal-note">
          <div className="text-xs uppercase tracking-[0.2em] text-sage-warn font-bold mb-2">Why "as long as we can"</div>
          <div className="text-sm text-sage-text sage-prose leading-relaxed">
            We believe giving away a full business stack to independent operators — the exact package Toast, Square, Clover, and their peers charge $200–$800/month for — is legal in every jurisdiction we've mapped so far. If a jurisdiction rules otherwise, Stadium Seat charges the local minimum required to comply and no more; the whole margin still routes to Overflow. The gift is the intent. The receipts stay public.
          </div>
        </div>

        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">What's in the box</div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-1">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Point-of-sale + payments</div>
              <div className="text-xs text-sage-muted sage-prose">Every table, every check, every card and cash split. Runs on Purser's flat rail, no per-swipe skim.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-2">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Inventory + ordering</div>
              <div className="text-xs text-sage-muted sage-prose">Prep sheets, par levels, waste tracking, weekly reorder drafts. Talks to your suppliers in one voice.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-3">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Staff scheduling + payroll drafts</div>
              <div className="text-xs text-sage-muted sage-prose">Shift board, availability, tip-pool math, and pay-period drafts you sign off on.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-4">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Menu + pricing designer</div>
              <div className="text-xs text-sage-muted sage-prose">Costed menus, printable and digital, updated when a supplier price moves.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-5">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Marketing + social</div>
              <div className="text-xs text-sage-muted sage-prose">Weekly specials on your channels, honest food photography via Loom, PostMaster ferries the posts.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-6">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Delivery + pickup</div>
              <div className="text-xs text-sage-muted sage-prose">One order feed across your own site, Uber Eats, DoorDash, GrubHub. No 30% skim by default — you keep the choice.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-7">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Books + tax prep</div>
              <div className="text-xs text-sage-muted sage-prose">Nightly close, monthly PL, year-end packet your CPA can actually use.</div>
            </div>
            <div className="border border-sage-border p-4" data-testid="stadium-seat-feature-8">
              <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Compliance calendar</div>
              <div className="text-xs text-sage-muted sage-prose">Liquor license, food-safety inspection, workers' comp, sales-tax filings — dates on the wall before the letters arrive.</div>
            </div>
          </div>
        </div>

        <div className="border border-sage-border p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">What the industry charges — and why we're giving it away</div>
          <div className="text-sm text-sage-text sage-prose leading-relaxed mb-3">
            Toast, Square for Restaurants, Clover, Lightspeed, TouchBistro — the same stack costs an independent operator $200–$800 a month, plus 1.5–3.5% per card swipe, plus per-terminal hardware fees, plus per-employee scheduling fees, plus per-menu digital-menu fees, plus 15–30% on every delivery order.
          </div>
          <div className="text-sm text-sage-text sage-prose leading-relaxed">
            One local bar-and-grill runs on ~$800/month of that stack today. Stadium Seat gives the whole thing away, priced at zero, ferried on Purser's flat rail. Every dollar we don't take is a dollar the operator keeps in the till — and the till is the whole point of running the shop.
          </div>
        </div>

        <div className="border border-sage-accent p-6 bg-sage-surface" data-testid="stadium-seat-signup">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-accent mb-3">Sign up · get the note when Stadium Seat opens</div>
          <div className="text-sm text-sage-muted sage-prose leading-relaxed mb-4">
            No commitment. No card. Just an email so we can tell you when the door opens. The first hundred operators to walk through get their setup fee waived (the industry charges $500–$2,000 for setup; ours will be near-zero even then).
          </div>
          <a
            href="/reach-out"
            className="inline-block border-2 border-sage-accent bg-sage-accent text-sage-bg px-6 py-3 text-sm font-bold uppercase tracking-[0.15em] hover:bg-sage-accent-hover transition-colors"
            data-testid="stadium-seat-signup-cta"
          >
            Tell Sage I want in →
          </a>
        </div>

        <div className="border-t border-sage-border pt-6 mt-10 text-xs text-sage-muted sage-prose">
          Stadium Seat is the free-tier bar-and-grill business package. The greedless pledge in ink: free for as long as the law allows it to be free. Every dollar the operator keeps is a dollar the industry doesn't skim off Main Street.
        </div>
      </div>
    </div>
  );
}
